import { LEVEL_BLOCAGE } from '@/configuration/tiers/levelBlocage';

export default function levelString(i18n, blocageLevel) {
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < LEVEL_BLOCAGE.length; i++) {
    if (LEVEL_BLOCAGE[i].key === blocageLevel) {
      return i18n.t(LEVEL_BLOCAGE[i].libelle);
    }
  }
  return '';
}
